import { NotScrollJournalPage } from "components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import styles from "./styles.module.scss";
import Left from "../../assets/images/paFirstPage/prof_left.png";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "../../shared/enums/commonEnums";
import leftRight from "../../assets/images/paFirstPage/leftRight.png";
import leftRight425 from "../../assets/images/paFirstPage/leftRight425.png";
import rightRight from "../../assets/images/paFirstPage/rightRight.png";

export const PersonalAccountFirstPage = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.personalaccaunt}>
      <NotScrollJournalPage
        leftContent={
          <div className={styles.containerLeft}>
            <img src={Left} alt="Personal Acaunt" />
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            <div className={styles.rightLeft}>
              {/* <img src={leftRight} alt="" className={styles.photo} /> */}
              <picture>
                <source media="(min-width: 640px)" srcSet={leftRight} />

                <img
                  src={leftRight425}
                  className={styles.photo}
                  alt="keylost"
                  loading="lazy"
                />
              </picture>
              <div className={styles.tetxtscontainerLeft}>
                <div className={styles.topLeft}>
                  <div className={styles.title}>Сканер Провизии</div>
                  <div className={styles.text}>
                    Сбалансированный рацион — основа сил героя. Следите за
                    балансом КБЖУ.
                  </div>
                  <div className={styles.text}>
                    Посмотрите КБЖУ за период и проанализируйте вплоть до приема
                    пищи
                  </div>
                  <Button
                    viewVariant="secondary"
                    className={styles.button}
                    text="Проверить"
                    onClick={() => navigate(RouterPathEnum.KBGU)}
                  />
                </div>
                <div className={styles.redLine} />
                <div className={styles.topLeft}>
                  <div className={styles.title}>Анализ метаболизма</div>
                  <div className={styles.text}>
                    Чтобы открыть точный расчет метаболизма, ваш Профиль Героя
                    должен быть заполнен на 100%. Система должна знать о вас
                    всё, чтобы дать самый точный совет!
                  </div>

                  <Button
                    viewVariant="secondary"
                    className={styles.button}
                    text="Проверить"
                    onClick={() => navigate(RouterPathEnum.Metabolism)}
                  />
                </div>
              </div>
            </div>

            <div className={styles.rightRight}>
              <img src={rightRight} alt="" className={styles.photoRight} />
              <div className={styles.tetxtscontainer}>
                <div className={styles.textholder}>
                  <div className={styles.title}>Беговая активность</div>
                  <div className={styles.textRight}>
                    Исследуйте реальный город, чтобы открыть тайны виртуального
                    мира, каждая пробежка отмечает новые локации на карте и даёт
                    вашему персонажу уникальные бонусы
                  </div>
                </div>
                <div className={styles.textholder}>
                  <div className={styles.title}>Мышечная активность</div>
                  <div className={styles.textRight}>
                    Превратите энергию своих мышц в силу удара для героя, наша
                    3D-модель покажет, какие группы мышц дают вам игровые
                    преимущества прямо сейчаc
                  </div>
                </div>
                <div className={styles.textholder}>
                  <div className={styles.title}>Когнитивные тренировки</div>
                  <div className={styles.textRight}>
                    Каждая решённая головоломка и упражнение на память заряжают
                    вашего героя интеллектуальной энергией
                  </div>
                </div>
                <Button
                  viewVariant="secondary"
                  className={styles.button}
                  text="Посмотреть"
                  onClick={() => navigate(RouterPathEnum.Main)}
                />
              </div>
            </div>
            {/* <img src={Right} alt="Personal Acaunt" />
            <Button
              viewVariant="primary"
              className={styles.position3}
              text="Проверить"
              onClick={() => navigate(RouterPathEnum.KBGU)}
            />

            <Button
              viewVariant="secondary"
              className={styles.position4}
              text="Проверить"
              onClick={() => navigate(RouterPathEnum.Metabolism)}
            />
           
            <Button
              viewVariant="secondary"
              className={styles.position6}
              text="Посмотреть"
              onClick={() => navigate(RouterPathEnum.Main)}
            />
         */}
          </div>
        }
      />
    </div>
  );
};
